import { useTranslation } from 'react-i18next';
import { ConditionalText } from '../ConditionalText/ConditionalText';
import { brand } from 'src/shared/branding/brand';

// Under the text rules the brand's own texts have their own box on the review
// step (SmsConsentBox), so this sentence keeps only the texts from Stripe.
const textSendersEn = brand.smsConsentRules
  ? 'its partner Stripe'
  : `${brand.displayName} and its partner Stripe`;
const textSendersEs = brand.smsConsentRules
  ? 'su socio Stripe'
  : `${brand.displayName} y su socio Stripe`;
const { signUpTerms } = brand;

export const FooterNote = () => {
  const { i18n } = useTranslation();
  return (
    <>
      {i18n.resolvedLanguage === 'en' && (
        <ConditionalText>
          By clicking Submit, you agree to {signUpTerms.ownerEn}{' '}
          <a target="_blank" href={brand.termsUrl}>
            {signUpTerms.termsLabelEn}
          </a>
          {signUpTerms.showPrivacyLink && (
            <>
              ,{' '}
              <a target="_blank" href={brand.privacyUrl}>
                Privacy Policy
              </a>
            </>
          )}{' '}
          and{' '}
          <a
            target="_blank"
            href="https://payup-docs.s3.us-east-2.amazonaws.com/PayUp+-+Vendor+Receivables+Purchase+Agreement(154531217.10)-05_04_2022.pdf"
          >
            Vendor Agreement
          </a>{' '}
          as well as receiving automated text messages from {textSendersEn}. You also agree to
          Stripe's{' '}
          <a target="_blank" href="https://stripe.com/issuing/payout-card-user-agreement/legal">
            Stripe Services Agreement and E-SIGN
          </a>
          , and{' '}
          <a target="_blank" href="https://stripe.com/treasury-connect-account/legal">
            Commercial Account Agreement
          </a>
          .
        </ConditionalText>
      )}

      {i18n.resolvedLanguage === 'es' && (
        <ConditionalText>
          Al hacer clic en Enviar, acepta los{' '}
          <a target="_blank" href={brand.termsUrl}>
            Términos de servicio
          </a>
          {signUpTerms.showPrivacyLink && (
            <>
              , la{' '}
              <a target="_blank" href={brand.privacyUrl}>
                Política de privacidad
              </a>
            </>
          )}{' '}
          y el{' '}
          <a
            target="_blank"
            href="https://payup-docs.s3.us-east-2.amazonaws.com/PayUp+-+Vendor+Receivables+Purchase+Agreement(154531217.10)-05_04_2022.pdf"
          >
            Acuerdo de proveedor
          </a>{' '}
          {signUpTerms.ownerEs}, así como la recepción de mensajes de texto automáticos de{' '}
          {textSendersEs}. También acepta el{' '}
          <a target="_blank" href="https://stripe.com/issuing/payout-card-user-agreement/legal">
            Acuerdo de servicios de Stripe y E-SIGN
          </a>{' '}
          y el{' '}
          <a target="_blank" href="https://stripe.com/treasury-connect-account/legal">
            Acuerdo de cuenta comercial
          </a>{' '}
          de Stripe.
        </ConditionalText>
      )}
    </>
  );
};
